import { render } from "./AiStartUpButtons.vue?vue&type=template&id=3499c531"
import script from "./AiStartUpButtons.vue?vue&type=script&lang=js"
export * from "./AiStartUpButtons.vue?vue&type=script&lang=js"

import "./AiStartUpButtons.vue?vue&type=style&index=0&id=3499c531&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiStartUpButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3499c531"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3499c531', __exports__)) {
    api.reload('3499c531', __exports__)
  }
  
  module.hot.accept("./AiStartUpButtons.vue?vue&type=template&id=3499c531", () => {
    api.rerender('3499c531', render)
  })

}


export default __exports__